export default "__VITE_ASSET__1663c80a__"